import { MessageCircle, Eye, Pin, Clock } from "lucide-react";

export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return "";
  const now = Date.now();
  const date = timestamp * 1000;
  const diff = now - date;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return "hace unos segundos";
  if (minutes < 60) return `hace ${minutes} min`;
  if (hours < 24) return `hace ${hours} ${hours === 1 ? "hora" : "horas"}`;
  if (days < 7) return `hace ${days} ${days === 1 ? "día" : "días"}`;
  if (weeks < 4) return `hace ${weeks} ${weeks === 1 ? "semana" : "semanas"}`;
  if (months < 12) return `hace ${months} ${months === 1 ? "mes" : "meses"}`;
  return `hace ${years} ${years === 1 ? "año" : "años"}`;
};

export const categoryColors = {
  "desarrollo": "#4ade80",
  "diseño": "#c084fc",
  "anuncio": "#fbbf24",
  "ciberseguridad": "#60a5fa",
  "general": "#94a3b8",
  "ayuda": "#fb923c",
  "técnicas": "#2dd4bf",
  "técnicas": "#2dd4bf",
  "tecnica": "#2dd4bf",
  "tecnologías": "#818cf8",
  "programación": "#4ade80",
  "programacion": "#4ade80",
  "default": "#94a3b8"
};

export const getCategoryColor = (categoryName) => {
  const normalized = categoryName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return categoryColors[normalized] || categoryColors.default;
};

// ID de la discusión/post del reglamento ("Reglamento Foro A8ISLAS")
export const RULES_DISCUSSION_ID = 29;

export const findNormasCategory = (themes = []) => {
  if (!Array.isArray(themes)) return null;

  const normalizeStr = (str) =>
    (str || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  // 1. Prioritize categories explicitly named with rules/guidelines
  for (const theme of themes) {
    if (Array.isArray(theme?.categories)) {
      const match = theme.categories.find((cat) => {
        const name = normalizeStr(cat?.name);
        return (
          name.includes("norma") ||
          name.includes("regla") ||
          name.includes("convivencia") ||
          name.includes("reglamento")
        );
      });
      if (match) return match;
    }
  }

  // 2. Fallback: theme named with rules/guidelines, return its first category
  for (const theme of themes) {
    const name = normalizeStr(theme?.name);
    if (
      name.includes("norma") ||
      name.includes("regla") ||
      name.includes("convivencia") ||
      name.includes("reglamento")
    ) {
      if (Array.isArray(theme?.categories) && theme.categories.length > 0) {
        return theme.categories[0];
      }
    }
  }

  return null;
};
